import { useSelector } from 'react-redux'
import { Container, Spacer, Text, Image, hooks } from 'roadie-ui'
import Panel, { PanelTitle } from 'components/layout/Panel'
import arriveByPickupTimeLight from 'images/my-stats/arrive-by-pickup-time-light.png'
import arriveByPickupTimeDark from 'images/my-stats/arrive-by-pickup-time-dark.png'
import { LocalizedRichText, useLocalization, LocalizedText } from 'localization'

const OnTimeRateTipsSection: React.FC = () => {
  const { t } = useLocalization()
  const isWebview = useSelector<any, boolean>((state) => state.config.isWebview)
  const colorScheme = hooks.usePreferredColorScheme()
  const arriveByPickupTime = colorScheme === 'dark' ? arriveByPickupTimeDark : arriveByPickupTimeLight

  return (
    <>
      <PanelTitle>
        <LocalizedText translationKey="dweb_dashboard_commitment_rate_tips_road_success" />
      </PanelTitle>
      <Panel left noPadding>
        <Container.Base $padding="2.4rem" $textAlign="left" $color="neutral-black">
          <Text.Body2>
            <LocalizedRichText
              translationKey="dweb_dashboard_commitment_rate_tips_keep_rate_above_strong_text1_access_more_gigs"
              params={{ strongText1: <strong>90%</strong> }}
            />
          </Text.Body2>

          <Spacer $height="1.6rem" />

          <Text.Body2>
            <LocalizedText translationKey="dweb_dashboard_on_time_rate_tips_section_look_arrive_by_time_top_right_corner_gig" />
          </Text.Body2>

          <Spacer $height="1.6rem" />

          <Container.Grid $width="100%" $justifyItems="center">
            <Image
              src={arriveByPickupTime}
              alt={t('dweb_dashboard_on_time_rate_tips_section_arrive_by_time_highlighted_gig_screen')}
              $width={isWebview ? '100%' : '50%'}
              $height="auto"
              $maxWidth="100%"
            />
          </Container.Grid>
        </Container.Base>
      </Panel>
    </>
  )
}

export default OnTimeRateTipsSection
